import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TrendingUp } from "lucide-react";
import { toast } from "sonner";

// Firm-wide default annual uplift %. Pre-fills the per-proposal uplift box (which stays editable).
export default function AnnualUpliftCard({ canEdit }) {
  const [pct, setPct] = useState("");
  useEffect(() => { api.get("/settings/annual-uplift").then((r) => setPct(r.data.pct)).catch(() => {}); }, []);
  const save = async () => {
    try { const { data } = await api.put("/settings/annual-uplift", { pct: Number(pct) || 0 }); setPct(data.pct); toast.success("Default annual uplift saved"); }
    catch { toast.error("Could not save"); }
  };
  return (
    <Card className="p-6 rounded-md space-y-3 max-w-md" data-testid="annual-uplift-card">
      <div className="flex items-center gap-2"><TrendingUp className="w-4 h-4 text-cass-teal" /><h4 className="font-alt font-semibold text-cass-navy">Annual fee uplift</h4></div>
      <p className="text-sm text-cass-slate">Default uplift % applied to recurring fees at renewal. It pre-fills the per-proposal uplift control (staff can change it or switch it off per proposal — it's <b>off by default</b> on new proposals).</p>
      <div className="flex items-end gap-2">
        <div><Label className="text-xs">Default uplift %</Label>
          <div className="flex items-center gap-1"><Input type="number" step="0.1" min={0} className="w-28 h-9" value={pct} disabled={!canEdit} onChange={(e) => setPct(e.target.value)} data-testid="annual-uplift-default-input" /><span className="text-sm text-cass-slate">%</span></div>
        </div>
        {canEdit && <Button className="bg-cass-navy text-white h-9" onClick={save} data-testid="annual-uplift-default-save">Save</Button>}
      </div>
    </Card>
  );
}
